import React from 'react';
import ProjectsTable from '../components/tables/ProjectsTable';

const Projects: React.FC = () => {
  return <ProjectsTable />;
};

export default Projects;
